import { IScope } from 'angular';
import { createContext, RefCallback, useContext } from 'react';

type AngularContextState = {
  setScope: RefCallback<IScope>;
  scope: IScope | null;
};

export const defaultState: AngularContextState = {
  setScope: () => null,
  scope: null,
};

export const AngularContext = createContext<AngularContextState>(defaultState);

export const useAngularContext = () => useContext(AngularContext);
